
import {BaseModel} from '../base/BaseModel';
import {CURRENT_USER} from '../../../js/resources/SessionObjects';
import { CropSeasonStatusModel } from '../timing/CropSeasonStatusModel';

/**
 * @class ApplicationMapDownloadModel
 * @extends BaseModel
 *
 * @property {object} attributes
 */
export class CrossFarmDashboardSearchModel extends BaseModel {

    initialize () {

        this.microservice = 'cross-farm-dashboard';
        this.resource = '_search';
    }

    request (data) {

        return $.ajax({
            url: (`${API_PREFIX}/${this.microservice}/${this.resource}`),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(data)
        });
    }

    // filters must be applied here as well!?!
    static getFarmUserFilter () {

        return {
            size: 10000,
            query: {
                match_phrase: {
                    entityType: 'FARM'
                }
            },
            aggs: {
                owners: {
                    terms: {
                        field: 'farmOwnerId.keyword',
                        size: 10000
                    }
                }
            }
        };
    }

    static getCropFilter () {

        return {
            size: 10000,
            query: {
                match_phrase: {
                    entityType: 'CROPSEASON'
                }
            },
            aggs: {
                crops: {
                    terms: {
                        field: 'cropType.keyword',
                        size: 10000
                    }
                }
            }
        };
    }

    static getDashboardStatsQuery (filters = {}) {

        const query = {
            size: 0,
            query: {
                bool: {
                    must: [
                        {
                            bool: {
                                should: [
                                    {
                                        match_phrase: {
                                            entityType: 'FARM'
                                        }
                                    },
                                    {
                                        match_phrase: {
                                            entityType: 'FIELD'
                                        }
                                    },
                                    {
                                        match_phrase: {
                                            entityType: 'TASK'
                                        }
                                    },
                                    {
                                        bool: {
                                            must: [
                                                {
                                                    bool: {
                                                        should: [
                                                            {
                                                                match_phrase: {
                                                                    entityType: 'CROPSEASON'
                                                                }
                                                            }
                                                        ],
                                                        'minimum_should_match': 1
                                                    }
                                                }
                                            ]
                                        }

                                    }
                                ],
                                minimum_should_match: 1
                            }
                        }
                    ]
                }
            },
            aggs: {
                userCount: {
                    cardinality: {
                        field: 'farmOwnerId.keyword',
                        precision_threshold: 40000
                    }
                },
                farmCount: {
                    cardinality: {
                        field: 'farmUuid.keyword',
                        precision_threshold: 40000
                    }
                },
                fieldStats: {
                    filter: {
                        match_phrase: {
                            entityType: 'FIELD'
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'fieldUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        totalArea: {
                            sum: {
                                field: 'fieldSize'
                            }
                        }
                    }
                },
                cropSeasonStats: {
                    filter: {
                        match_phrase: {
                            entityType: 'CROPSEASON'
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'cropSeasonUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        totalArea: {
                            sum: {
                                field: 'fieldSize'
                            }
                        }
                    }
                },
                sprayingTaskStats: {
                    filter: {
                        bool: {
                            must: [
                                {
                                    match_phrase: {
                                        entityType: 'TASK'
                                    }
                                },
                                {
                                    match_phrase: {
                                        taskType: 'SPRAYING'
                                    }
                                }
                            ]
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'sprayingUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        planned: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'PLANNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        executed: {
                            filter: {
                                bool: {
                                    should: [
                                        {
                                            match_phrase: {
                                                executionStatus: 'EXECUTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'AUTO_EXECUTED'
                                            }
                                        }
                                    ],
                                    minimum_should_match: 1
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        overdued: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'OVERDUE'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        accepted: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'ACCEPTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        rejected: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'REJECTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unacknowledged: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNACKNOWLEDGED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unassigned: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNASSIGNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        }
                    }
                },
                scoutingTaskStats: {
                    filter: {
                        bool: {
                            must: [
                                {
                                    match_phrase: {
                                        entityType: 'TASK'
                                    }
                                },
                                {
                                    match_phrase: {
                                        taskType: 'SCOUTING'
                                    }
                                }
                            ]
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'scoutingTaskUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        planned: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'PLANNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        executed: {
                            filter: {
                                bool: {
                                    should: [
                                        {
                                            match_phrase: {
                                                executionStatus: 'EXECUTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'AUTO_EXECUTED'
                                            }
                                        }
                                    ],
                                    minimum_should_match: 1
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        overdued: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'OVERDUE'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        accepted: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'ACCEPTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        rejected: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'REJECTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unacknowledged: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNACKNOWLEDGED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unassigned: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNASSIGNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        }
                    }
                },
                droneFlightTaskStats: {
                    filter: {
                        bool: {
                            must: [
                                {
                                    match_phrase: {
                                        entityType: 'TASK'
                                    }
                                },
                                {
                                    match_phrase: {
                                        taskType: 'DRONEFLIGHT'
                                    }
                                }
                            ]
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'droneFlightTaskUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        planned: {
                            filter: {
                                bool: {
                                    should: [
                                        {
                                            match_phrase: {
                                                executionStatus: 'PLANNED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'SCHEDULED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'EXECUTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'CANCELLED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'PROCESSING_FAILED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'PROCESSING_DENIED_QUOTA_EXHAUSTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'RE_SUBMITTED'
                                            }
                                        }
                                    ],
                                    minimum_should_match: 1
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        executed: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'PROCESSED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        accepted: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'ACCEPTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        rejected: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'REJECTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unacknowledged: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNACKNOWLEDGED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unassigned: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNASSIGNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        }
                    }
                },
                riskAndRecommendationStats: {
                    filter: {
                        match_phrase: {
                            entityType: 'CROPSEASON'
                        }
                    },
                    aggs: {
                        cropSeasonStatusesStats: {
                            nested: {
                                path: 'cropSeasonStatuses'
                            },
                            aggs: {
                                diseaseRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'DISEASE'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                insectRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'INSECT'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                lodgingRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'LODGING'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                nutritionRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'NUTRITION'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        recommendationStats: {
                            nested: {
                                path: 'actionRecommendations'
                            },
                            aggs: {
                                excludeNotNeeded: {
                                    filter: {
                                        bool: {
                                            must: [{
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.status': 'RECOMMENDED'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.status': 'NECESSARY'
                                                            }
                                                        }
                                                    ],
                                                    'minimum_should_match': 1
                                                }
                                            }]
                                        }
                                    },
                                    aggs: {
                                        fungicideRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'FUNGICIDE_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        insecticideRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'INSECTICIDE_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        pgrRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'PLANT_GROWTH_REGULATOR_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        nutritionRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'FERTILIZER_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };

        CrossFarmDashboardSearchModel.applyGeneralFiltersToQuery(query, filters);
        CrossFarmDashboardSearchModel.fieldStatsEntityTypeToCropSeason(query, filters);

        return query;
    }

    static getGeneralDataQuery( filters = {}) {
        const query = {
            size: 10000,
            query: {
                bool: {
                    must: [
                        {
                            bool: {
                                should: [
                                    {
                                        match_phrase: {
                                            entityType: 'FARM'
                                        }
                                    },
                                    {
                                        match_phrase: {
                                            entityType: 'FIELD'
                                        }
                                    },
                                    {
                                        match_phrase: {
                                            entityType: 'CROPSEASON'
                                        }
                                    }
                                ],
                                minimum_should_match: 1
                            }
                        }
                    ]
                }
            },
            aggs: {
                userCount: {
                    cardinality: {
                        field: 'farmOwnerId.keyword',
                        precision_threshold: 40000
                    }
                },
                farmCount: {
                    cardinality: {
                        field: 'farmUuid.keyword',
                        precision_threshold: 40000
                    }
                },
                fieldStats: {
                    filter: {
                        match_phrase: {
                            entityType: 'FIELD'
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'fieldUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        totalArea: {
                            sum: {
                                field: 'fieldSize'
                            }
                        }
                    }
                },
                cropSeasonStats: {
                    filter: {
                        match_phrase: {
                            entityType: 'CROPSEASON'
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'cropSeasonUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        totalArea: {
                            sum: {
                                field: 'fieldSize'
                            }
                        },
                        statsGroupedByCrop: {
                            terms: {
                                field: 'cropType.keyword',
                                size: 10000
                            },
                            aggs: {
                                totalArea: {
                                    sum: {
                                        field: 'fieldSize'
                                    }
                                },
                                fieldCount: {
                                    cardinality: {
                                        field: 'fieldUuid.keyword'
                                    }
                                }
                            }
                        }
                    }
                },
                fieldsAndCropSeasons: {
                    filter: {
                        bool: {
                            should: [
                                {
                                    match_phrase: {
                                        entityType: 'FIELD'
                                    }
                                },
                                {
                                    match_phrase: {
                                        entityType: 'CROPSEASON'
                                    }
                                }
                            ],
                            minimum_should_match: 1
                        }
                    },
                    aggs: {
                        fieldsWithoutCropSeason: {
                            terms: {
                                field: "fieldUuid.keyword",
                                order: {
                                    _count: "asc"
                                },

                                size: 10000
                            },
                            aggs: {
                                fieldUuidKeyCount: {
                                    value_count: {
                                        field: 'fieldUuid.keyword'
                                    }
                                },
                                state_filter: {
                                    bucket_selector: {
                                        buckets_path: {
                                            fieldUuidKeyCount: 'fieldUuidKeyCount'
                                        },
                                        script: 'params.fieldUuidKeyCount == 1'
                                    }
                                }
                            }
                        },
                        fieldsWithCropSeason: {
                            filter: {
                                match: {
                                    entityType: 'CROPSEASON'
                                }
                            },
                            aggs: {
                                fields: {
                                    terms: {
                                        field: 'fieldUuid.keyword',
                                        size: 10000
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };

        CrossFarmDashboardSearchModel.applyGeneralFiltersToQuery(query, filters);
        CrossFarmDashboardSearchModel.fieldStatsEntityTypeToCropSeason(query, filters);

        return query;
    }

    static applyGeneralFiltersToQuery(query, filters) {
        
        const {farms, users, crops, headFilter} = filters;

        const { 
            isHealthyField
        } = headFilter;


        farms && farms.length && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart(farms, 'farmUuid'));

        users && users.length && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart(users, 'farmOwnerId'));

        crops && crops.length && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart(crops, 'cropType'));


        isHealthyField && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart([true], 'isHealthyField'));
    }

    static fieldStatsEntityTypeToCropSeason(query, filters) {

        const { crops, headFilter } = filters;
        const { isHealthyField } = headFilter;

        if(crops && crops.length) {

            // If crop filter exists, getting stats for entityType FIELD makes no sense
            // Cropseason is unique and elastic search provides only active crop seasons
            // Hence field count, area is same as cropseason count, area
            query.aggs.fieldStats.filter.match_phrase.entityType = 'CROPSEASON';
            query.aggs.fieldStats.aggs.count.cardinality.field = 'cropSeasonUuid.keyword';
        }

        if (isHealthyField) {

            // Treating healthy fields case as if a crop filter is selected
            query.aggs.fieldStats.filter.match_phrase.entityType = 'CROPSEASON';
            query.aggs.fieldStats.aggs.count.cardinality.field = 'cropSeasonUuid.keyword';
        }
    }

    static getMatchPart(searchItems, matchPhrase) {

        const searchObjects = searchItems.map((item) => {
            return {
                match_phrase: {
                    [matchPhrase]: item
                }
            };
        });

        return {
            bool: {
                should: searchObjects,
                minimum_should_match: 1
            }
        };
    }

    static getTaskDataQuery (generalFilters = {}, taskFilters = {}) {

        const query = {
            size: 10000,
            query: {
                bool: {
                    must: [
                        {
                            bool: {
                                should: [
                                    {
                                        match_phrase: {
                                            entityType: 'TASK'
                                        }
                                    }
                                ],
                                minimum_should_match: 1
                            }
                        }
                    ]
                }
            },
            aggs: {
                sprayingTaskStats: {
                    filter: {
                        bool: {
                            must: [
                                {
                                    match_phrase: {
                                        taskType: 'SPRAYING'
                                    }
                                }
                            ]
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'sprayingUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        planned: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'PLANNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        executed: {
                            filter: {
                                bool: {
                                    should: [
                                        {
                                            match_phrase: {
                                                executionStatus: 'EXECUTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'AUTO_EXECUTED'
                                            }
                                        }
                                    ],
                                    minimum_should_match: 1
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        overdued: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'OVERDUE'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        accepted: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'ACCEPTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        rejected: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'REJECTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unacknowledged: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNACKNOWLEDGED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unassigned: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNASSIGNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'sprayingUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        }
                    }
                },
                scoutingTaskStats: {
                    filter: {
                        bool: {
                            must: [
                                {
                                    match_phrase: {
                                        taskType: 'SCOUTING'
                                    }
                                }
                            ]
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'scoutingTaskUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        planned: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'PLANNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        executed: {
                            filter: {
                                bool: {
                                    should: [
                                        {
                                            match_phrase: {
                                                executionStatus: 'EXECUTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'AUTO_EXECUTED'
                                            }
                                        }
                                    ],
                                    minimum_should_match: 1
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        overdued: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'OVERDUE'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        accepted: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'ACCEPTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        rejected: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'REJECTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unacknowledged: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNACKNOWLEDGED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unassigned: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNASSIGNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'scoutingTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        }
                    }
                },
                droneFlightTaskStats: {
                    filter: {
                        bool: {
                            must: [
                                {
                                    match_phrase: {
                                        entityType: 'TASK'
                                    }
                                },
                                {
                                    match_phrase: {
                                        taskType: 'DRONEFLIGHT'
                                    }
                                }
                            ]
                        }
                    },
                    aggs: {
                        count: {
                            cardinality: {
                                field: 'droneFlightTaskUuid.keyword',
                                precision_threshold: 40000
                            }
                        },
                        planned: {
                            filter: {
                                bool: {
                                    should: [
                                        {
                                            match_phrase: {
                                                executionStatus: 'PLANNED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'SCHEDULED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'EXECUTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'CANCELLED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'PROCESSING_FAILED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'PROCESSING_DENIED_QUOTA_EXHAUSTED'
                                            }
                                        },
                                        {
                                            match_phrase: {
                                                executionStatus: 'RE_SUBMITTED'
                                            }
                                        }
                                    ],
                                    minimum_should_match: 1
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        executed: {
                            filter: {
                                match_phrase: {
                                    executionStatus: 'PROCESSED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        accepted: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'ACCEPTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        rejected: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'REJECTED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unacknowledged: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNACKNOWLEDGED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        },
                        unassigned: {
                            filter: {
                                match_phrase: {
                                    assignmentStatus: 'UNASSIGNED'
                                }
                            },
                            aggs: {
                                count: {
                                    cardinality: {
                                        field: 'droneFlightTaskUuid.keyword',
                                        precision_threshold: 40000
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };

        CrossFarmDashboardSearchModel.applyGeneralFiltersToQuery(query, generalFilters);
        CrossFarmDashboardSearchModel.applyTaskFiltersToQuery(query, taskFilters);

        return query;
    }

    static applyTaskFiltersToQuery(query, filters) {

        const { taskTypes, taskDate, executionStates, assignmentStates, headFilter } = filters;
        const { isAssignedToMe } = headFilter;

        // @TODO: To be moved to a better place by Martin
        if (_.includes(executionStates, 'EXECUTED')) {
            executionStates.push('AUTO_EXECUTED');
        }

        taskTypes && taskTypes.length && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart(taskTypes, 'taskType'));

        executionStates && executionStates.length && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart(executionStates, 'executionStatus'));

        assignmentStates && assignmentStates.length && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart(assignmentStates, 'assignmentStatus'));

        // @TODO: This is a temporary solution as we do not have mapping between gigya UID and task assigneeUuid which is collaboratorUuid
        isAssignedToMe && query.query.bool.must
            .push(CrossFarmDashboardSearchModel.getMatchPart([`${CURRENT_USER.get('firstName')} ${CURRENT_USER.get('lastName')}`], 'assigneeName'));

        if (taskDate) {

            if (taskDate.start) {

                const start = moment(taskDate.start);
                const object = {
                    bool: {
                        should: [],
                        minimum_should_match: 1
                    }
                };

                object.bool.should[0] = {
                    range: {
                        plannedDate: {
                            gte: BaseModel.serializeDate(start.startOf('d'))
                        }
                    }
                };

                object.bool.should[1] = {
                    range: {
                        executionDate: {
                            gte: BaseModel.serializeDate(start.startOf('d'))
                        }
                    }
                };

                object.bool.should[1] = {
                    range: {
                        executionStatusDate: {
                            gte: BaseModel.serializeDate(start.startOf('d'))
                        }
                    }
                };

                query.query.bool.must.push(object);

            }

            if (taskDate.end) {

                const end = moment(taskDate.end);
                const object = {
                    bool: {
                        should: [],
                        minimum_should_match: 1
                    }
                };

                object.bool.should[0] = {
                    range: {
                        plannedDate: {
                            lte: BaseModel.serializeDate(end.endOf('d'))
                        }
                    }
                };

                object.bool.should[1] = {
                    range: {
                        executionDate: {
                            lte: BaseModel.serializeDate(end.endOf('d'))
                        }
                    }
                };

                object.bool.should[1] = {
                    range: {
                        executionStatusDate: {
                            lte: BaseModel.serializeDate(end.endOf('d'))
                        }
                    }
                };

                query.query.bool.must.push(object);
            }
        }
    }

    static getRisksAndRecommendationsDataQuery (generalFilters = {}, riskFilters = {}) {

        const query = {
            size: 10000,
            query: {
                bool: {
                    must: [
                        {
                            bool: {
                                should: [
                                    {
                                        match_phrase: {
                                            entityType: 'CROPSEASON'
                                        }
                                    }
                                ],
                                minimum_should_match: 1
                            }
                        }
                    ]
                }
            },
            aggs: {
                riskAndRecommendationStats: {
                    filter: {
                        match_phrase: {
                            entityType: 'CROPSEASON'
                        }
                    },
                    aggs: {
                        cropSeasonStatusesStats: {
                            nested: {
                                path: 'cropSeasonStatuses'
                            },
                            aggs: {
                                diseaseRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'DISEASE'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                insectRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'INSECT'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                lodgingRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'LODGING'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                nutritionRiskStats: {
                                    filter: {
                                        bool: {
                                            must: [
                                                {
                                                    match_phrase: {
                                                        'cropSeasonStatuses.type': 'NUTRITION'
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    aggs: {
                                        noInfo: {
                                            filter: {
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'NO_INFORMATION'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'cropSeasonStatuses.status': 'INACTIVE'
                                                            }
                                                        }
                                                    ],
                                                    minimum_should_match: 1
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        high: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'HIGH'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        medium: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'MEDIUM'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        low: {
                                            filter: {
                                                match_phrase: {
                                                    'cropSeasonStatuses.status': 'LOW'
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        recommendationStats: {
                            nested: {
                                path: 'actionRecommendations'
                            },
                            aggs: {
                                excludeNotNeeded: {
                                    filter: {
                                        bool: {
                                            must: [{
                                                bool: {
                                                    should: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.status': 'RECOMMENDED'
                                                            }
                                                        },
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.status': 'NECESSARY'
                                                            }
                                                        }
                                                    ],
                                                    'minimum_should_match': 1
                                                }
                                            }]
                                        }
                                    },
                                    aggs: {
                                        fungicideRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'FUNGICIDE_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        insecticideRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'INSECTICIDE_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        pgrRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'PLANT_GROWTH_REGULATOR_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        nutritionRecommendationStats: {
                                            filter: {
                                                bool: {
                                                    must: [
                                                        {
                                                            match_phrase: {
                                                                'actionRecommendations.type': 'FERTILIZER_APPLICATION'
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            aggs: {
                                                uniqueCropSeasons: {
                                                    reverse_nested: {},
                                                    aggs: {
                                                        count: {
                                                            cardinality: {
                                                                field: 'cropSeasonUuid.keyword',
                                                                precision_threshold: 40000
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        purpleDotStats: {
                            nested: {
                                path: 'actionRecommendationAggregations'
                            },
                            aggs: {
                                activeCount: {
                                    filter: {
                                        match_phrase: {
                                            'actionRecommendationAggregations.status': 'ACTIVE'
                                        }
                                    },
                                    aggs: {
                                        uniqueCropSeasons: {
                                            reverse_nested: {},
                                            aggs: {
                                                count: {
                                                    cardinality: {
                                                        field: 'cropSeasonUuid.keyword',
                                                        precision_threshold: 40000
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };

        CrossFarmDashboardSearchModel.applyGeneralFiltersToQuery(query, generalFilters);
        CrossFarmDashboardSearchModel.applyRiskFiltersToQuery(query, riskFilters);

        return query;
    }

    static applyRiskFiltersToQuery(query, filters) {

        let {
            recommendationTypes,
            recommendationDate,
            riskTypes,
            riskLevels,
        } = filters;

        if ((recommendationTypes && recommendationTypes.length) ||
            (recommendationDate && (recommendationDate.start || recommendationDate.end))) {

            let object = {
                bool: {
                    should: [
                        {
                            nested: {
                                path: 'actionRecommendations',
                                query: {
                                    bool: {
                                        must: [{
                                            bool: {
                                                should: [
                                                    {
                                                        match_phrase: {
                                                            'actionRecommendations.status': 'RECOMMENDED'
                                                        }
                                                    },
                                                    {
                                                        match_phrase: {
                                                            'actionRecommendations.status': 'NECESSARY'
                                                        }
                                                    }
                                                ],
                                                'minimum_should_match': 1
                                            }
                                        }]
                                    }
                                }
                            }
                        }
                    ],
                    minimum_should_match: 1
                }
            };

            if (recommendationTypes && recommendationTypes.length) {

                let recommendationTypeObject = {
                    bool: {
                        should: [],
                        minimum_should_match: 1
                    }
                };

                _.each(recommendationTypes, (type) => {

                    let searchObject = {
                        match_phrase: {
                            'actionRecommendations.type': type
                        }
                    };

                    recommendationTypeObject.bool.should.push(searchObject);
                });

                object.bool.should[0].nested.query.bool.must.push(recommendationTypeObject);
            }

            if (recommendationDate) {

                if(recommendationDate.start || recommendationDate.end) {

                    if (recommendationDate.start) {

                        const start = moment(recommendationDate.start);
                        let startDateObject = {
                            bool: {
                                should: [{
                                    range: {
                                        'actionRecommendations.startDate': {
                                            gte: BaseModel.serializeDate(start.startOf('d'))
                                        }
                                    }
                                }],
                                minimum_should_match: 1
                            }
                        };

                        object.bool.should[0].nested.query.bool.must.push(startDateObject);
                    }

                    if (recommendationDate.end) {

                        const end = moment(recommendationDate.end);
                        let endDateObject = {
                            bool: {
                                should: [{
                                    range: {
                                        'actionRecommendations.startDate': {
                                            lte: BaseModel.serializeDate(end.endOf('d'))
                                        }
                                    }
                                }],
                                minimum_should_match: 1
                            }
                        };

                        object.bool.should[0].nested.query.bool.must.push(endDateObject);
                    }
                }
            }

            query.query.bool.must.push(object);
        }

        if ((riskLevels && riskLevels.length) ||
            (recommendationDate && (recommendationDate.start || recommendationDate.end))) {

            let object = {
                bool: {
                    should: [
                        {
                            nested: {
                                path: 'cropSeasonStatuses',
                                query: {
                                    bool: {
                                        must: []
                                    }
                                }
                            }
                        }
                    ],
                    minimum_should_match: 1
                }
            };

            if (riskTypes && riskTypes.length) {

                let riskTypeObject = {
                    bool: {
                        should: [],
                        minimum_should_match: 1
                    }
                };

                _.each(riskTypes, (type) => {

                    let searchObject = {
                        match_phrase: {
                            'cropSeasonStatuses.type': type
                        }
                    };

                    riskTypeObject.bool.should.push(searchObject);
                });

                object.bool.should[0].nested.query.bool.must.push(riskTypeObject);
            }

            if (riskLevels && riskLevels.length) {

                riskLevels.indexOf(CropSeasonStatusModel.state.NO_INFORMATION) !== -1 && riskLevels.push(CropSeasonStatusModel.state.INACTIVE);

                let riskLevelObject = {
                    bool: {
                        should: [],
                        minimum_should_match: 1
                    }
                };

                _.each(riskLevels, (level) => {

                    let searchObject = {
                        match_phrase: {
                            'cropSeasonStatuses.status': level
                        }
                    };

                    riskLevelObject.bool.should.push(searchObject);
                });

                object.bool.should[0].nested.query.bool.must.push(riskLevelObject);
            }

            if (recommendationDate) {

                if(recommendationDate.start || recommendationDate.end) {

                    if (recommendationDate.start) {

                        const start = moment(recommendationDate.start);
                        let startDateObject = {
                            bool: {
                                should: [{
                                    range: {
                                        'cropSeasonStatuses.startDate': {
                                            gte: BaseModel.serializeDate(start.startOf('d'))
                                        }
                                    }
                                }],
                                minimum_should_match: 1
                            }
                        };

                        object.bool.should[0].nested.query.bool.must.push(startDateObject);
                    }

                    if (recommendationDate.end) {

                        const end = moment(recommendationDate.end);
                        let endDateObject = {
                            bool: {
                                should: [{
                                    range: {
                                        'cropSeasonStatuses.startDate': {
                                            lte: BaseModel.serializeDate(end.endOf('d'))
                                        }
                                    }
                                }],
                                    minimum_should_match: 1
                            }
                        };

                        object.bool.should[0].nested.query.bool.must.push(endDateObject);
                    }
                }
            }

            query.query.bool.must.push(object);
        }
    }

    static fetchFieldsFromCfd ({northWest, southEast}) {

        return $.ajax({
            url: (API_PREFIX + '/cross-farm-dashboard/_search'),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                _source: [
                    'fieldUuid'
                ],
                size: 10000,
                query: {
                    bool: {
                        must: [
                            {
                                bool: {
                                    must: [
                                        {
                                            match_phrase: {
                                                entityType: 'FIELD'
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                bool: {
                                    must: {
                                        match_all: {}
                                    },
                                    filter: {
                                        geo_bounding_box: {
                                            fieldLocation: {
                                                top_left: {
                                                    lat: northWest.lat,
                                                    lon: northWest.lng
                                                },
                                                bottom_right: {
                                                    lat: southEast.lat,
                                                    lon: southEast.lng
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            })
        });
    }
}



// WEBPACK FOOTER //
// ./shared/model/cross-farm-dashboard/CrossFarmDashboardSearchModel.js